/**
 * MERCADO LIVRE OAUTH SERVICE - BACKEND AS SINGLE SOURCE OF TRUTH
 * 
 * Frontend apenas redireciona para backend e verifica status.
 * Backend é a ÚNICA fonte de verdade para OAuth.
 * Nenhum cache ou localStorage usado como fonte principal.
 */

// Backend URLs
const BACKEND_BASE_URL = 'https://vinteveapi.online';
const BACKEND_LOGIN_URL = `${BACKEND_BASE_URL}/ml/login`;
const BACKEND_STATUS_URL = `${BACKEND_BASE_URL}/ml/status`;

/**
 * Redireciona navegador para URL de login do backend
 * Backend gerencia todo o fluxo OAuth e redireciona de volta
 */
export function openBackendLogin() {
  console.log('[ML OAuth] 🔗 Redirecionando para backend login:', BACKEND_LOGIN_URL);
  window.location.href = BACKEND_LOGIN_URL;
}

/**
 * Verifica status de conexão com backend - ÚNICA FONTE DE VERDADE
 * @returns {Promise<Object>} Status de conexão
 */
export async function checkConnectionStatus() {
  try {
    console.log('[ML OAuth] 🔍 Verificando status com backend:', BACKEND_STATUS_URL);
    
    const response = await fetch(BACKEND_STATUS_URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      mode: 'cors'
    });
    
    if (!response?.ok) {
      throw new Error(`Backend retornou ${response.status}`);
    }
    
    const data = await response?.json();
    console.log('[ML OAuth] ✅ Status do backend:', data);
    
    return {
      success: true,
      connected: data?.connected || false,
      user_id: data?.user_id || null
    };
  } catch (error) {
    // Detectar erro de CORS/rede
    const isCorsError = error?.message === 'Failed to fetch' || error?.message?.includes('CORS') ||
                        error?.message?.includes('Network') ||
                        error?.name === 'TypeError';
    
    if (isCorsError) {
      console.warn(
        '[ML OAuth] ⚠️ Backend não acessível - Configure CORS em vinteveapi.online\n' +
        `Adicione este domínio: ${window.location?.origin}\n` +
        'Headers necessários:\n' +
        `  Access-Control-Allow-Origin: ${window.location?.origin}\n` +
        '  Access-Control-Allow-Credentials: true'
      );
      
      return {
        success: false,
        connected: false,
        user_id: null,
        error: 'Backend não configurado para aceitar requisições deste domínio',
        errorType: 'CORS',
        helpText: `Configure o backend em vinteveapi.online para permitir requisições de ${window.location?.origin}`
      };
    }
    
    console.error('[ML OAuth] ❌ Erro ao verificar status:', error?.message);
    
    return {
      success: false,
      connected: false,
      user_id: null,
      error: error?.message || 'Erro ao conectar com backend',
      errorType: 'UNKNOWN'
    };
  }
}

/**
 * Desconecta (deve chamar endpoint do backend)
 */
export function disconnect() {
  console.log('[ML OAuth] 🔌 Desconectando...');
  // Backend deve gerenciar desconexão
  return { success: true };
}

// Placeholder exports para compatibilidade
function getConnectionStatus(...args) {
  console.warn('Placeholder: getConnectionStatus is not implemented yet.', args);
  return null;
}

export { getConnectionStatus };

function generateAuthorizationUrl(...args) {
  console.warn('Placeholder: generateAuthorizationUrl is not implemented yet.', args);
  return null;
}

export { generateAuthorizationUrl };

function exchangeCodeForToken(...args) {
  console.warn('Placeholder: exchangeCodeForToken is not implemented yet.', args);
  return null;
}

export { exchangeCodeForToken };

function refreshAccessToken(...args) {
  console.warn('Placeholder: refreshAccessToken is not implemented yet.', args);
  return null;
}

export { refreshAccessToken };